import React from 'react';
import { useSelector } from 'react-redux';
import { selectCurrentFlow } from '../../store/slices/flow/flowSelectors';
import GeneralPageLayout from '../../components/layout/GeneralPageLayout';
import { useCloseWindow } from '../../hooks/useCloseWindow';
import {
  selectConfigSettings,
  selectConfigExpressSettingsName,
} from '../../store/slices/config/configSelectors';
import { selectPaymentSuccessInfo } from '../../store/slices/payment/paymentSelectors';

const PaymentCompleted = () => {
  const paymentSuccessInfo = useSelector(selectPaymentSuccessInfo);
  const placeDisplayName = useSelector(selectConfigExpressSettingsName);
  const settings = useSelector(selectConfigSettings);
  const { express, rentalType } = settings;
  const currentFlow = useSelector(selectCurrentFlow);

  const { isAbleToCloseWindow, closeWindow } = useCloseWindow();

  return (
    <GeneralPageLayout
      flow={currentFlow}
      next="Close Window"
      showNext={isAbleToCloseWindow}
      onNext={closeWindow}
    >
      <p>
        Thank you! Your {express?.registration?.verbiage} Application has been
        submitted successfully!{' '}
        {paymentSuccessInfo?.paymentConfirmation
          ? ` Your confirmation number is: ${paymentSuccessInfo?.paymentConfirmation}.`
          : ''}{' '}
        We have emailed you details of the application. Your application will be
        reviewed and processed by {placeDisplayName} {rentalType.toUpperCase()}.
        We will contact you via email on the status of your application.
      </p>
    </GeneralPageLayout>
  );
};

export default PaymentCompleted;
